/* ============
 * Mutation types for the tracking module
 * ============
 *
 * The mutation types that are available
 * on the tracking module.
 */

export const SET_TRACKING = 'SET_TRACKING';
export const SET_TRACKING_TO_EDIT = 'SET_TRACKING_TO_EDIT';
export const SET_FILTERED_TRACKINGS = 'SET_FILTERED_TRACKINGS';
export const NEXT_STEP = 'NEXT_STEP';
export const PREV_STEP = 'PREV_STEP';
export const SET_STEP = 'SET_STEP';
export const SET_ERRORS = 'SET_ERRORS';
export const RESET_FORM = 'RESET_FORM';
export const CREATE_TRACKING = 'CREATE_TRACKING';
export const UPDATE_TRACKING = 'UPDATE_TRACKING';
export const DELETE_TRACKING = 'DELETE_TRACKING';
export const RESET_STATE = 'RESET_STATE';

export default {
  SET_TRACKING,
  SET_TRACKING_TO_EDIT,
  SET_FILTERED_TRACKINGS,
  NEXT_STEP,
  PREV_STEP,
  SET_STEP,
  RESET_FORM,
  SET_ERRORS,
  CREATE_TRACKING,
  UPDATE_TRACKING,
  DELETE_TRACKING,
  RESET_STATE,
};
